if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        console.log(this)
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const sectionsToRender = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : null;
        if (this.cart) {
          formData.append('sections', sectionsToRender);
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // --- Welcome Kit ---
        // The product page widget injects a hidden "gift_items" input (JSON) describing each gift.
        // When present, the main product and every gift are sent together as JSON "items" so they
        // land in the cart in one request. Gifts never carry a selling plan, so on a subscription
        // they are charged on the first order only. The cart drawer cannot read the product
        // block's settings, so each gift line carries them as hidden "_" properties instead.
        const giftItems = this.getGiftItems();
        formData.delete('gift_items');
        let includesGift = false;

        if (giftItems.length) {
          const mainItem = this.buildItemFromFormData(formData);
          // Remember which product earned the gift, so the cart drawer folds it into that line
          // rather than whichever product happens to sit first in the cart.
          giftItems.forEach((gift) => {
            gift.properties._gift_for = String(mainItem.id);
          });
          const payload = { items: [mainItem].concat(giftItems) };
          if (this.cart) {
            payload.sections = sectionsToRender;
            payload.sections_url = window.location.pathname;
          }
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(payload);
          includesGift = true;
        } else {
          config.body = formData;
        }

        const submitRequest = (requestConfig) =>
          fetch(`${routes.cart_add_url}`, requestConfig).then((response) => response.json());

        submitRequest(config)
          .then((response) => {
            // If the combined add failed, retry with the main product only so the customer is not blocked.
            if (response.status && includesGift) {
              console.warn('Welcome kit could not be added, retrying without it:', response.description);
              const fallbackConfig = fetchConfig('javascript');
              fallbackConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete fallbackConfig.headers['Content-Type'];
              fallbackConfig.body = formData;
              return submitRequest(fallbackConfig);
            }
            return response;
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              console.log("i am finally herer....");
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      getGiftItems() {
        const giftInput = this.form.querySelector('input[name="gift_items"]');
        if (!giftInput || giftInput.disabled || !giftInput.value) return [];

        let config;
        try {
          config = JSON.parse(giftInput.value);
        } catch (e) {
          console.warn('Welcome kit config could not be read:', e);
          return [];
        }

        const gifts = Array.isArray(config.items) ? config.items : [];
        return gifts
          // One of each per order: skip any gift already sitting in the cart. Gifts folded into
          // a product's "Included free" panel are not rendered as cart rows, so both the row and
          // the panel are checked. Missing the panel is what let a second gift through.
          .filter(
            (gift) =>
              gift &&
              gift.id &&
              !document.querySelector(
                `.cart-item[data-variant-id="${gift.id}"], [data-gift-variant-id="${gift.id}"]`
              )
          )
          .map((gift) => {
            const properties = {
              _welcome_gift: 'true',
              _gift_free: config.free || 'FREE',
              _gift_fold: config.fold === false ? 'false' : 'true',
            };
            if (gift.label) properties._gift_label = gift.label;
            if (gift.hide) properties._gift_hide = String(gift.hide);
            // The real item packed as this gift, so the order tells fulfilment what to send.
            // Underscore-prefixed, so customers never see it in the cart or at checkout.
            if (gift.contains) properties._gift_contains = String(gift.contains);
            return { id: parseInt(gift.id, 10), quantity: 1, properties };
          });
      }

      buildItemFromFormData(formData) {
        const item = {
          id: parseInt(formData.get('id'), 10),
          quantity: parseInt(formData.get('quantity'), 10) || 1,
        };
        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) item.selling_plan = parseInt(sellingPlan, 10);

        const properties = {};
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = value;
        }
        if (Object.keys(properties).length) item.properties = properties;
        return item;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
